import type { ReactNode } from 'react';

import { Card } from '@/components/common/Card/Card';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/common.module.css';

type EmptyTone = 'default' | 'warning' | 'danger';

type EmptyStateProps = {
  title: string;
  description: string;
  action?: ReactNode;
  icon?: ReactNode;
  tone?: EmptyTone;
  className?: string;
};

const toneClassName: Record<EmptyTone, string | undefined> = {
  default: undefined,
  warning: styles.emptyToneWarning,
  danger: styles.emptyToneDanger,
};

export function EmptyState({
  title,
  description,
  action,
  icon,
  tone = 'default',
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <Card tone="soft" className={classNames(styles.emptyState, toneClassName[tone], className)}>
      {icon ? <div className={styles.emptyIcon}>{icon}</div> : null}
      <div>
        <p className={styles.emptyTitle}>{title}</p>
        <p className={styles.emptyDescription}>{description}</p>
      </div>
      {action ? <div className={styles.emptyActions}>{action}</div> : null}
    </Card>
  );
}
